"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsCreateFeaturesMutation = void 0;
const useModelsMutation_1 = require("./useModelsMutation");
function useModelsCreateFeaturesMutation(accountNumber, featureCollectionId) {
    return useModelsMutation_1.useModelsMutation(accountNumber, 'PATCH', `/feature-collections/${featureCollectionId}/features`, (features) => ({ featuresToCreate: features }), { featureCollection: featureCollectionId });
}
exports.useModelsCreateFeaturesMutation = useModelsCreateFeaturesMutation;
//# sourceMappingURL=useModelsCreateFeaturesMutation.js.map